import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "tabs-wrapper" };
const _hoisted_2 = { class: "main-content tab-router-wrapper" };
import vuexStore from '@/vuex-store';
import { computed, ref, toRefs, } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        tabs: { default: () => [] },
        hideSlider: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { tabs } = toRefs(props);
        const selectedTab = ref(0);
        const userPermission = computed(() => (vuexStore.getters['user/getterUserPermission']));
        const allowTabs = computed(() => (tabs.value.reduce((acc, it) => {
            const { tabAuthorization } = it;
            // tabAuthorization 키 없거나 비어있으면 pass
            if (!tabAuthorization || !tabAuthorization.length) {
                acc.push(it);
                return acc;
            }
            if (userPermission.value(tabAuthorization)) {
                acc.push(it);
            }
            return acc;
        }, [])));
        return (_ctx, _cache) => {
            const _component_v_tab = _resolveComponent("v-tab");
            const _component_v_tabs = _resolveComponent("v-tabs");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(tabs).length > 0)
                    ? (_openBlock(), _createBlock(_component_v_tabs, {
                        key: 0,
                        class: "tabs-btn",
                        "v-model": selectedTab.value
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowTabs.value, (tab) => {
                                return (_openBlock(), _createBlock(_component_v_tab, {
                                    key: tab.name,
                                    to: tab.to
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tab.name), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["v-model"]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Router 2 Depth "),
                    _createVNode(_component_router_view)
                ])
            ]));
        };
    }
});
